import React, { useContext, useEffect, useState } from "react";
import { titleCase } from "../../../../Utility";
import {
  isMobile,
  currentRequestTimeStamp,
  Activity,
} from "../../../../Constants";
import Axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import { toast } from "react-toastify";

import mixpanel from "mixpanel-browser";
import axios from "../../../../Axios/Axios";
import Loader from "../../../Loader";
import { DataGhost } from "../../../Planning/components/EmptyState";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const getLastRate = (transporter) => {
  const rateList = transporter?.rate_list || [];
  return rateList.length ? rateList[rateList.length - 1] : null;
};

const isAcceptedApprovalPendingTransporter = (transporter) => {
  const lastRate = getLastRate(transporter);
  return (
    lastRate &&
    lastRate.bid_status === "accepted" &&
    (transporter.main_status === "approval_pending" ||
      lastRate.main_status === "approval_pending" ||
      (transporter.main_status !== "approved" && lastRate.main_status !== "approved"))
  );
};

const getMatchingTransporters = (item) => {
  return (item.transporter_list || item.transporter_rate_list || []).filter(
    isAcceptedApprovalPendingTransporter
  );
};

const getTenure = (tenure) => {
  if (!tenure) return "NA";
  if (typeof tenure === "string") return tenure;
  if (Array.isArray(tenure) && tenure.length > 0) {
    return tenure[0].label || tenure[0].value || "NA";
  }
  if (typeof tenure === "object") return tenure.label || tenure.value || "NA";
  return "NA";
};

const getTruckLabel = (truckTypes) => {
  if (!truckTypes) return "NA";
  if (Array.isArray(truckTypes)) {
    const labels = truckTypes
      .map((truck) => truck?.label || truck?.value || truck)
      .filter(Boolean);
    return labels.length ? labels.join(", ") : "NA";
  }
  return truckTypes?.label || truckTypes?.value || truckTypes || "NA";
};

const getLaneData = (item) => {
  const lane = item.lane_details || item;
  const origin = lane.origin || item.origin;
  const destination = lane.destination || item.destination;
  const truckTypes = lane.truck_types || item.truck_types;

  return {
    originName:
      origin?.location?.location ||
      origin?.location_name ||
      item.origin?.location?.location ||
      item.origin?.location_name ||
      "NA",
    destName:
      destination?.location?.location ||
      destination?.location_name ||
      item.destination?.location?.location ||
      item.destination?.location_name ||
      "NA",
    truckLabel: getTruckLabel(truckTypes),
    truck_required: lane.truck_required || item.truck_required || "NA",
    contract_tenure: lane.contract_tenure || item.contract_tenure,
    due_date: lane.due_date || item.due_date || "NA",
  };
};

const HeaderCell = ({ width, children, style = {} }) => (
  <div
    style={{
      width,
      textAlign: "center",
      fontWeight: "bolder",
      fontSize: "13px",
      ...style,
    }}
  >
    {children}
  </div>
);

const RequestApproval = ({
  requestapprovallist = [],
  approverList = [],
}) => {
  const [approvalList, setApprovalList] = useState([]);
  const [show, setshow] = useState(false);
  const [finalPayload, setFinalPayload] = useState({});
  const [remarks, setRemarks] = useState({});

  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  useEffect(() => {
    if (!requestapprovallist || requestapprovallist.length === 0) {
      setApprovalList([]);
      setFinalPayload({});
      setshow(false);
      return;
    }

    setshow(true);
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - request approval",
      Data: "None",
      Definition: "user clicked on request approval button",
    });

    const promises = requestapprovallist.map((item) =>
      axios.get(`${Urls.spot}?field=get_enquiry&truck_enquiry_id=${item.truck_enquiry_id}`)
    );

    Promise.all(promises)
      .then((results) => {
        const newList = [];
        const initialFinalPayload = {};

        results.forEach((res, index) => {
          const enquiryId = requestapprovallist[index].truck_enquiry_id;
          const enquiryData = res.data.enquiry_lane_details
            ? res.data.enquiry_lane_details[0]
            : res.data;
          const tList = enquiryData?.transporter_list || enquiryData?.transporter_rate_list || [];
          const selectedTransporters = tList
            .filter(isAcceptedApprovalPendingTransporter)
            .map((transporter) => transporter.transporter_id);

          if (selectedTransporters.length > 0) {
            initialFinalPayload[enquiryId] = selectedTransporters;
            newList.push({
              ...requestapprovallist[index],
              ...enquiryData,
              truck_enquiry_id: enquiryData.truck_enquiry_id || enquiryId,
              transporter_list: tList,
            });
          }
        });

        setFinalPayload(initialFinalPayload);
        setApprovalList(newList);
        setshow(false);
      })
      .catch((err) => {
        setshow(false);
        console.log(err, "54");
      });
  }, [requestapprovallist]);

  const changeHandler = (e, item, transporter) => {
    const enquiryId = item.truck_enquiry_id;
    const transporterId = transporter.transporter_id;
    const key = `${enquiryId}_${transporterId}`;

    setFinalPayload((prevPayload) => {
      const selectedTransporters = prevPayload[enquiryId] || [];
      const nextPayload = { ...prevPayload };

      if (e.target.checked) {
        nextPayload[enquiryId] = Array.from(
          new Set([...selectedTransporters, transporterId])
        );
      } else {
        const updatedTransporters = selectedTransporters.filter(
          (id) => id !== transporterId
        );

        if (updatedTransporters.length > 0) {
          nextPayload[enquiryId] = updatedTransporters;
        } else {
          delete nextPayload[enquiryId];
        }

        // Remove remark if unchecked
        setRemarks((prevRemarks) => {
          const nextRemarks = { ...prevRemarks };
          delete nextRemarks[key];
          return nextRemarks;
        });
      }

      return nextPayload;
    });
  };

  const remarkChangeHandler = (e, enquiryId, transporterId) => {
    const key = `${enquiryId}_${transporterId}`;
    const value = e.target.value;
    setRemarks((prev) => ({
      ...prev,
      [key]: value,
    }));
  };



  const ClickHandler = () => {
    if (Object.keys(finalPayload).length === 0) {
      toast.error("Please select at least one transporter");
      return;
    }

    mixpanel.track("User has clicked on Request Approval Button", {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Trucksavailable",
      ModuleName: "my_enquiries",
      ActivityLog: "userClickedRequestApprovalButton",
      Data: "",
      Definition: "User has clicked on Request Approval",
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - request approval",
      Data: `enq ids: ${JSON.stringify(finalPayload)}`,
      Definition: "user has clicked on request approval submit button",
    });

    Activity([
      {
        screen: "LoRRI Adhoc",
        module: "Request Approval",
        user_activity: "Approval requested",
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    const formattedPayload = {};
    Object.keys(finalPayload).forEach((enqId) => {
      formattedPayload[enqId] = finalPayload[enqId].map((tId) => ({
        transporter_id: tId,
        remark: remarks[`${enqId}_${tId}`] || "",
      }));
    });

    Axios.put(`${Urls.spot}?field=request_bulk_approve_v2`, {
      enquiry_ids: formattedPayload,
    })
      .then((res) => {
        if (res.data?.status === "error") {
          toast.info(res.data?.message);
          return;
        }
        if (res.data?.results && Array.isArray(res.data.results)) {
          const failures = res.data.results.filter((r) => r.status === "failed");
          failures.forEach((f) => {
            toast.error(
              `${f.display_adhoc_id || f.truck_enquiry_id}: ${f.reason}`
            );
          });
          if (failures.length === res.data.results.length) return;
        }
        toast.success("Approval Requested");
        document.getElementById("close_contactus")?.click();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const isChecked = (item, transporter) => {
    return !!(
      finalPayload &&
      finalPayload[item.truck_enquiry_id] &&
      finalPayload[item.truck_enquiry_id].includes(transporter.transporter_id)
    );
  };

  const renderDesktopList = () => (
    <>
      <div style={{ display: "flex", borderBottom: "1px solid lightgrey", padding: "10px 0" }}>
        <HeaderCell width="4%">Select</HeaderCell>
        <HeaderCell width="6%">User</HeaderCell>
        <HeaderCell width="12%">Adhoc ID</HeaderCell>
        <HeaderCell width="10%">Origin</HeaderCell>
        <HeaderCell width="10%">Destination</HeaderCell>
        <HeaderCell width="10%">Truck Type</HeaderCell>
        <HeaderCell width="5%" style={{ whiteSpace: "nowrap" }}># Trucks</HeaderCell>
        <HeaderCell width="8%">Contract tenure</HeaderCell>
        <HeaderCell width="8%">Date of Placement</HeaderCell>
        <HeaderCell width="12%">Transporter Name</HeaderCell>
        <HeaderCell width="10%">Rate Accepted</HeaderCell>
        <HeaderCell width="10%">Remarks</HeaderCell>
      </div>

      {approvalList.map((item, index) => {
        const matchingTransporters = getMatchingTransporters(item);
        if (matchingTransporters.length === 0) return null;

        const {
          originName,
          destName,
          truckLabel,
          truck_required,
          contract_tenure,
          due_date,
        } = getLaneData(item);
        const userEmail = item.email ? titleCase(item.email.split("@")[0]) : "User";
        const adhocId = item.display_adhoc_id || "NA";
        const hasMultipleQuotes = matchingTransporters.length > 1;

        return (
          <div
            key={`enquiry${item.truck_enquiry_id || index}`}
            style={{
              width: "100%",
              borderBottom: "1px solid lightgrey",
              borderLeft: hasMultipleQuotes ? "4px solid #393185" : "none",
              backgroundColor: hasMultipleQuotes ? "#fcfbff" : "transparent",
              marginBottom: "8px",
            }}
          >
            {matchingTransporters.map((transporter, i) => {
              const lastRate = getLastRate(transporter);
              const rate = lastRate?.rate !== undefined && lastRate?.rate !== null
                ? lastRate.rate.toLocaleString()
                : "NA";
              const remark = lastRate?.remark;

              return (
                <div
                  key={`transporter_enquiry${transporter.transporter_id || i}`}
                  style={{ display: "flex", padding: "1%", alignItems: "center" }}
                >
                  <div style={{ width: "4%", textAlign: "center", fontSize: "13px" }}>
                    <input
                      type="checkbox"
                      checked={isChecked(item, transporter)}
                      style={{ height: "15px", width: "15px", cursor: "pointer" }}
                      onChange={(e) => changeHandler(e, item, transporter)}
                    />
                  </div>
                  <div style={{ width: "6%", textAlign: "center", fontSize: "13px" }}>
                    {i === 0 ? userEmail : ""}
                  </div>
                  <div style={{ width: "12%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    {i === 0 ? adhocId : ""}
                  </div>
                  <div style={{ width: "10%", textAlign: "center", fontSize: "13px" }}>
                    {i === 0 && originName !== "NA" ? (
                      <>
                        <i className="fa fa-map-marker" style={{ color: "#393186", marginRight: "4px" }} />
                        <span style={{ cursor: "pointer" }}>{originName}</span>
                      </>
                    ) : i === 0 ? "NA" : ""}
                  </div>
                  <div style={{ width: "10%", textAlign: "center", fontSize: "13px" }}>
                    {i === 0 && destName !== "NA" ? (
                      <>
                        <i className="fa fa-map-marker" style={{ color: "#393186", marginRight: "4px" }} />
                        <span style={{ cursor: "pointer" }}>{destName}</span>
                      </>
                    ) : i === 0 ? "NA" : ""}
                  </div>
                  <div style={{ width: "10%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    {i === 0 ? truckLabel : ""}
                  </div>
                  <div style={{ width: "5%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    {i === 0 ? truck_required || "NA" : ""}
                  </div>
                  <div style={{ width: "8%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    {i === 0 ? getTenure(contract_tenure) : ""}
                  </div>
                  <div style={{ width: "8%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    {i === 0 ? due_date : ""}
                  </div>
                  <div style={{ width: "12%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    {transporter.transporter_name}
                  </div>
                  <div style={{ width: "10%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    {rate}
                    {remark && (
                      <div style={{ fontSize: "11px", color: "#888", marginTop: "2px", whiteSpace: "normal" }}>
                        <i>Note: {remark}</i>
                      </div>
                    )}
                  </div>
                  <div style={{ width: "10%", textAlign: "center", fontSize: "13px", color: "#666" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Add remark..."
                      value={remarks[`${item.truck_enquiry_id}_${transporter.transporter_id}`] || ""}
                      disabled={!isChecked(item, transporter)}
                      onChange={(e) => remarkChangeHandler(e, item.truck_enquiry_id, transporter.transporter_id)}
                      style={{
                        fontSize: "11px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "4px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );

  const renderMobileList = () =>
    approvalList.map((item, index) => {
      const matchingTransporters = getMatchingTransporters(item);
      if (matchingTransporters.length === 0) return null;

      const { originName, destName, truckLabel, truck_required, due_date } = getLaneData(item);

      return (
        <div
          key={`mob_${item.truck_enquiry_id || index}`}
          style={{
            border: "1px solid #dee2e6",
            borderRadius: "8px",
            padding: "12px",
            marginBottom: "15px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          <div style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}>
            {originName} → {destName}
          </div>
          <div style={{ fontSize: "12px", color: "#666", marginBottom: "10px", marginTop: "4px" }}>
            {item.display_adhoc_id || "NA"} | {truckLabel} | {truck_required} Trucks | {due_date}
          </div>

          {matchingTransporters.map((transporter, i) => {
            const lastRate = getLastRate(transporter);
            const rate = lastRate?.rate !== undefined && lastRate?.rate !== null
              ? lastRate.rate.toLocaleString()
              : "NA";
            const remark = lastRate?.remark;

            return (
              <div
                key={`mob_trans_${transporter.transporter_id || i}`}
                style={{
                  borderTop: i > 0 ? "1px solid #eee" : "none",
                  paddingTop: "10px",
                  marginTop: "10px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    checked={isChecked(item, transporter)}
                    onChange={(e) => changeHandler(e, item, transporter)}
                    style={{ marginRight: "10px", height: "18px", width: "18px" }}
                  />
                  <b style={{ fontSize: "13px" }}>{transporter.transporter_name}</b>
                </div>
                <div style={{ paddingLeft: "28px", marginBottom: "8px", fontWeight: "bold", color: "#393185", fontSize: "14px" }}>
                  ₹{rate}
                </div>
                  <div style={{ marginTop: "8px" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Add remark..."
                      value={remarks[`${item.truck_enquiry_id}_${transporter.transporter_id}`] || ""}
                      disabled={!isChecked(item, transporter)}
                      onChange={(e) => remarkChangeHandler(e, item.truck_enquiry_id, transporter.transporter_id)}
                      style={{ fontSize: "12px" }}
                    />
                  </div>
              </div>
            );
          })}
        </div>
      );
    });

  return (
    <>
      <Loader show={show} />
      {requestapprovallist.length > 0 ? (
        <div>
          {!isMobile() && (
            <div
              style={{
                padding: "0 20px 10px 20px",
                fontSize: "12px",
                color: "#666",
                borderBottom: "1px solid #eee",
                marginBottom: "10px",
              }}
            />
          )}

          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            {approvalList && approvalList.length > 0 ? (
              !isMobile() ? renderDesktopList() : renderMobileList()
            ) : (
              show === false && (
                <center className="pb-5">
                  <DataGhost
                    title="Looks like you have no enquiries for request approval"
                    hasSubtitle={false}
                  />
                </center>
              )
            )}
          </div>

          <center style={{ padding: "1%" }}>
            <button
              className="btn btn-sm btn-primary"
              disabled={Object.keys(finalPayload).length === 0}
              onClick={() => ClickHandler()}
            >
              Request Approval
            </button>
          </center>
        </div>
      ) : (
        <div>Please select enquiries</div>
      )}
    </>
  );
};

export default RequestApproval;